module.exports = __webpack_public_path__ + "static/media/icon.cbc80be2.png";